<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAddressStore } from '@stores/useAddressStore';
import { trans } from '@elements/translation';
import { UserAuth } from '@tools/user/auth';
import { NonRestrictedAddressCategories, RestrictedAddressCategories } from './enum';

defineProps({
  activeTab: {
    type: String,
    required: true,
  },
});

const store = useAddressStore();
const { currentPageSpace } = storeToRefs(store);

const emit = defineEmits([ 'tab-change' ]);

const tabs = computed(() => (UserAuth.isImpersonated() && currentPageSpace.value !== null
  ? RestrictedAddressCategories
  : NonRestrictedAddressCategories));

const onTabChange = (tab) => {
  emit('tab-change', tab);
};

</script>

<template>
  <div class="page-header__tabs">
    <ul class="tabs">
      <li
        v-for="tab in tabs"
        :key="tab"
        :class="{ active: activeTab === tab }"
        @click="onTabChange(tab)"
      >
        {{ trans(`addresses.details.header.${tab}`) }}
      </li>
    </ul>
  </div>
</template>
